import React from "react";
import {
  TextField,
  RaisedButton,
  RadioButtonGroup,
  RadioButton,
  Checkbox
} from "material-ui";
import { Link } from "react-router";
import debounce from "lodash/debounce";

import connectToStores from "alt-utils/lib/connectToStores";
import UserStore from "../stores/UserStore";
import TagStore from "../stores/TagStore";
import TagActions from "../actions/TagActions";
import ConfiguratorItem from "./partials/configurator/configurator-item.jsx";
import SelectField from "./partials/select-field.jsx";
import Label from "./partials/label.jsx";
import InfoNotice from "./partials/info-notice.jsx";
import QuillEditor from "./partials/quill-editor.jsx";

class BallotingSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showFavorite: false
    };
    this.updateSettingDebounced = debounce(
      this.updateSettingDebounced.bind(this),
      500
    );
  }

  static getStores() {
    return [TagStore];
  }

  static getPropsFromStores() {
    return {
      getTagsForEventBucket: TagStore.getTagsForEventBucket
    };
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentDidMount() {
    TagActions.fetchAllForBucket.defer(this.props.eventBucket.id);
  }

  updateSettingDebounced(k, v) {
    this.props.updateSetting(k, v);
  }

  getStyles() {
    return {
      radio: {
        marginTop: "-0.5em",
        marginBottom: "1em"
      }
    };
  }

  getTagNameById(id) {
    var tags = this.props.getTagsForEventBucket(this.props.eventBucket.id);
    if (tags) {
      for (let t = 0; t < tags.length; t++) {
        if (id === tag[t].id) {
          return tag[t].name;
        }
      }
    }
    return "";
  }

  render() {
    const styles = this.getStyles();

    var tags = this.props.getTagsForEventBucket(this.props.eventBucket.id);

    var selectedTagIds = this.props.settings
      .online_ballot_custom_introduction_tags;
    var selectedTags = [];

    if (tags && tags.length > 0 && selectedTagIds) {
      selectedTags = selectedTagIds.map(id => {
        for (let t = 0; t < tags.length; t++) {
          if (id === tags[t].id) {
            return {
              label: tags[t].name,
              value: id
            };
          }
        }
      });
    }

    var selectedTagHeaders =
      this.props.settings
        .online_ballot_custom_introduction_by_tagging_modal_headers || {};

    return (
      <div>
        <p>
          Set up ballots for {this.props.eventBucket.name} below. All changes
          will be saved automatically.
        </p>
        <InfoNotice style={{ marginBottom: "1.5em", fontSize: "10pt" }}>
          Questions? Check out our{" "}
          <a
            href="https://help.eventive.org/eventive-balloting/getting-started/set-up-ballots"
            target="_blank"
          >
            guide to setting up ballots
          </a>
          .
        </InfoNotice>
        {this.props.eventBucket.enable_virtual_festival ? (
          <div>
            <h3>Virtual balloting</h3>
            <p>
              Enable virtual balloting on a per-screening basis via the event
              editor.
              <br /> Once votes have been tabulated, you can globally close
              voting here.
            </p>
            <RadioButtonGroup
              style={styles.radio}
              name="virtual_festival_voting_enabled"
              valueSelected={
                this.props.settings.virtual_festival_voting_enabled
                  ? "true"
                  : "false"
              }
              onChange={(e, v) =>
                this.props.updateSetting(
                  "virtual_festival_voting_enabled",
                  v === "true"
                )
              }
            >
              <RadioButton value="true" label={"Open for voting"} />
              <RadioButton value="false" label={"Voting closed"} />
            </RadioButtonGroup>
          </div>
        ) : null}
        {true ? (
          <div>
            <h3>Online balloting for physical events</h3>
            <p style={{ marginBottom: 10 }}>
              Allow users to vote on films from their "My Tickets" page on your
              Eventive site. When enabled, attendees will automatically be
              emailed and/or texted after each physical event to submit their
              votes.
            </p>
            <Checkbox
              label="Enable online balloting for physical events"
              checked={
                this.props.settings.online_balloting_for_physical_events_enabled
              }
              onCheck={(e, v) =>
                this.props.updateSetting(
                  "online_balloting_for_physical_events_enabled",
                  v
                )
              }
            />
            {this.props.settings
              .online_balloting_for_physical_events_enabled ? (
              <div>
                <p>
                  Enable online balloting on a per-film basis via the film
                  editor.
                  <br />
                  Once votes have been tabulated, you can globally close online
                  voting here.
                </p>
                <RadioButtonGroup
                  style={styles.radio}
                  name="online_balloting_voting_enabled"
                  valueSelected={
                    this.props.settings.online_balloting_voting_enabled
                      ? "true"
                      : "false"
                  }
                  onChange={(e, v) =>
                    this.props.updateSetting(
                      "online_balloting_voting_enabled",
                      v === "true"
                    )
                  }
                >
                  <RadioButton value="true" label={"Open for voting"} />
                  <RadioButton value="false" label={"Voting closed"} />
                </RadioButtonGroup>
                <Checkbox
                  style={{ paddingBottom: 0 }}
                  label="Require ticket scan in order to vote"
                  checked={
                    this.props.settings.online_balloting_require_ticket_scan
                  }
                  disabled={
                    this.props.settings
                      .online_balloting_for_physical_events_enabled === false
                  }
                  onCheck={(e, v) =>
                    this.props.updateSetting(
                      "online_balloting_require_ticket_scan",
                      v
                    )
                  }
                />
                <Checkbox
                  style={{ paddingBottom: 0 }}
                  label="Enable custom introduction for different tags"
                  checked={
                    this.props.settings
                      .online_balloting_custom_introduction_by_tagging
                  }
                  disabled={
                    this.props.settings
                      .online_balloting_for_physical_events_enabled === false
                  }
                  onCheck={(e, v) =>
                    this.props.updateSetting(
                      "online_balloting_custom_introduction_by_tagging",
                      v
                    )
                  }
                />
                {this.props.settings
                  .online_balloting_custom_introduction_by_tagging ? (
                  <div>
                    <Label>Tag(s) with custom ballot introductions</Label>
                    <SelectField
                      value={selectedTags}
                      multi={true}
                      style={{ maxWidth: 300 }}
                      options={tags.map(t => {
                        return {
                          label: t.name,
                          value: t.id
                        };
                      })}
                      onChange={selected => {
                        this.setState({ selectedTags: selected });
                        let selectedIds = selected.map(v => {
                          return v.value;
                        });
                        this.props.updateSetting(
                          "online_ballot_custom_introduction_tags",
                          selectedIds
                        );
                      }}
                    />
                    {selectedTags.map(tag => {
                      return (
                        <div>
                          <p>
                            <strong>
                              Online ballot custom introduction (
                              {tag ? tag.label : "custom"})
                            </strong>
                            : Edit custom content displayed at the top of the
                            online ballot modal window for all events/films with
                            this tag.
                          </p>
                          <div style={{ marginTop: "1.5em", maxWidth: 600 }}>
                            <QuillEditor
                              id={"quill_" + tag.id}
                              value={selectedTagHeaders[tag.value]}
                              inlineBasicOnly={false}
                              bounds=".EventBucketConfigurator--container"
                              onChange={content => {
                                // If the editor is empty, save just an empty string to the database,
                                // not the <div><br></div> stub that is generated by quill
                                let temp = document.createElement("div");
                                temp.innerHTML = content;

                                selectedTagHeaders[tag.value] = content;
                                if (temp.innerText.trim() === "") {
                                  selectedTagHeaders[tag.value] = "";
                                } else {
                                  selectedTagHeaders[tag.value] = content;
                                }
                                this.updateSettingDebounced(
                                  "online_ballot_custom_introduction_by_tagging_modal_headers",
                                  selectedTagHeaders
                                );
                              }}
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                ) : null}
                <p>
                  <strong>
                    {this.props.settings
                      .online_balloting_custom_introduction_by_tagging
                      ? "Online ballot introduction (default)"
                      : "Online ballot introduction"}
                  </strong>
                  : Edit custom content displayed at the top of the online
                  ballot modal window.
                </p>
                <div style={{ marginTop: "1.5em", maxWidth: 600 }}>
                  <ConfiguratorItem
                    eventBucket={this.props.eventBucket}
                    item={{ key: "online_ballot_modal_header", type: "html" }}
                    config={this.props.settings}
                    onConfigChange={(_, v) =>
                      this.updateSettingDebounced(
                        "online_ballot_modal_header",
                        v
                      )
                    }
                    onConfigFocus={() => {}}
                    onConfigBlur={() => {}}
                    onForcePreview={() => {}}
                    onEndForcePreview={() => {}}
                  />
                </div>
                <p>
                  <strong>Notification email introduction</strong>: Edit custom
                  content displayed at the top of the online ballot notification
                  email.
                </p>
                <div style={{ marginTop: "1.5em", maxWidth: 600 }}>
                  <ConfiguratorItem
                    eventBucket={this.props.eventBucket}
                    item={{
                      key: "online_ballot_notification_email_header",
                      type: "html"
                    }}
                    config={this.props.settings}
                    onConfigChange={(_, v) =>
                      this.updateSettingDebounced(
                        "online_ballot_notification_email_header",
                        v
                      )
                    }
                    onConfigFocus={() => {}}
                    onConfigBlur={() => {}}
                    onForcePreview={() => {}}
                    onEndForcePreview={() => {}}
                  />
                </div>
              </div>
            ) : (
              <div style={{ marginBottom: 20 }} />
            )}
          </div>
        ) : null}
        <h3>Ballot design</h3>
        <p>Configure the design of your ballot.</p>
        <RadioButtonGroup
          style={styles.radio}
          name="design"
          valueSelected={this.props.settings.design}
          onChange={(e, v) => this.props.updateSetting("design", v)}
        >
          <RadioButton
            value="rank"
            label={"Rank each film (A-F, 5-1, custom, etc.)"}
          />
          <RadioButton
            value="updown"
            label={"Thumbs up / thumbs down for each film"}
          />
        </RadioButtonGroup>
        {this.props.settings.design === "rank" ? (
          <div>
            <Label>Ranking labels</Label>
            <RadioButtonGroup
              name="rank_labels"
              valueSelected={
                ["5, 4, 3, 2, 1", "A, B, C, D, F"].indexOf(
                  this.props.settings.rank_labels
                ) !== -1
                  ? this.props.settings.rank_labels
                  : "custom"
              }
              onChange={(e, v) => {
                if (v === "custom") {
                  this.props.updateSetting(
                    "rank_labels",
                    this.props.settings.rank_labels + " "
                  );
                  this.rankLabels.focus();
                } else {
                  this.props.updateSetting("rank_labels", v);
                }
              }}
            >
              <RadioButton
                value="A, B, C, D, F"
                label="Letter (A, B, C, D, F)"
              />
              <RadioButton value="5, 4, 3, 2, 1" label="Numeric (5-1)" />
              <RadioButton value="custom" label="Custom" />
            </RadioButtonGroup>
            <TextField
              ref={r => {
                this.rankLabels = r;
              }}
              floatingLabelText={
                <div style={{ whiteSpace: "nowrap" }}>
                  Ranking labels (best → worst, comma-separated)
                </div>
              }
              floatingLabelFixed={true}
              value={this.props.settings.rank_labels}
              onChange={(e, v) => this.props.updateSetting("rank_labels", v)}
            />
            <div style={{ marginBottom: "1em" }}>
              <Label>Mobile/virtual-specific settings</Label>
              <Checkbox
                label="Use stars instead of rank labels in mobile ballots"
                checked={this.props.settings.rank_labels_stars}
                onCheck={(e, v) =>
                  this.props.updateSetting("rank_labels_stars", v)
                }
              />
              <Checkbox
                label={
                  'For mobile/virtual ballots with >3 films, show "pick your favorite"'
                }
                checked={
                  this.state.showFavorite ||
                  this.props.settings.rank_labels_favorite
                }
                onCheck={(e, v) => {
                  this.props.updateSetting("rank_labels_favorite", v ? 1 : 0);
                  this.setState({ showFavorite: v });
                }}
              />
            </div>
          </div>
        ) : null}
        <h3>Tabulation method</h3>
        <InfoNotice style={{ marginTop: "1em", fontSize: "10pt" }}>
          Learn about our different{" "}
          <a
            href="https://help.eventive.org/eventive-balloting/introduction-to-ballot-tabulation"
            target="_blank"
          >
            available tabulation methods
          </a>
          .
        </InfoNotice>
        <p>Select your desired tabulation method.</p>
        <div>
          <RadioButtonGroup
            style={styles.radio}
            name="tabulation_method"
            valueSelected={this.props.settings.tabulation_method}
            onChange={(e, v) =>
              this.props.updateSetting("tabulation_method", v)
            }
          >
            <RadioButton
              value="eventive"
              label={
                <span>
                  Eventive formula <i>(recommended)</i>
                </span>
              }
            />
            <RadioButton value="imdb" label={<span>IMDb formula</span>} />
            <RadioButton value="average" label={<span>Simple average</span>} />
          </RadioButtonGroup>
        </div>
        {["imdb", "average"].indexOf(this.props.settings.tabulation_method) !==
        -1 ? (
          <TextField
            style={{ marginTop: "-1em", marginBottom: "0.5em" }}
            floatingLabelText={
              <div style={{ whiteSpace: "nowrap" }}>
                Minimum votes for consideration
              </div>
            }
            floatingLabelFixed={true}
            value={this.props.settings.minimum_votes}
            onChange={(e, v) => this.props.updateSetting("minimum_votes", v)}
          />
        ) : null}
        <h3>Print ballot header</h3>
        <p>Edit custom content displayed at the top of each printed ballot.</p>
        <div style={{ marginTop: "1.5em", maxWidth: 600 }}>
          <ConfiguratorItem
            eventBucket={this.props.eventBucket}
            item={{ key: "ballot_header", type: "html" }}
            config={this.props.settings}
            onConfigChange={(_, v) =>
              this.updateSettingDebounced("ballot_header", v)
            }
            onConfigFocus={() => {}}
            onConfigBlur={() => {}}
            onForcePreview={() => {}}
            onEndForcePreview={() => {}}
          />
        </div>
        <h3>Balloted films</h3>
        <p>By default:</p>
        <ul>
          <li>A ballot will be generated for every applicable event</li>
          <li>
            Every event containing at least one{" "}
            <Link to={`event_buckets/${this.props.eventBucket.id}/films`}>
              film
            </Link>{" "}
            is balloted
          </li>
          <li>
            Films can be excluded by setting their balloting status to "Not in
            competition" via the film editor
          </li>
          <li>
            Events with multiple films (e.g. shorts blocks) will generate a
            single ballot containing all films screening as part of the event
          </li>
          <li>
            Events with no balloted films (e.g. parties) will not generate
            ballots
          </li>
        </ul>
        {UserStore.isGod() ? (
          <div>
            <h3>God settings</h3>
            <Label>Virtual consolidated balloting</Label>
            <Checkbox
              label="Use virtual consolidated voting (single screen, all must be watched)"
              checked={this.props.settings.virtual_festival_consolidated_voting}
              onCheck={(e, v) =>
                this.props.updateSetting(
                  "virtual_festival_consolidated_voting",
                  v
                )
              }
            />
            {this.props.settings.virtual_festival_consolidated_voting ? (
              <TextField
                style={{ marginBottom: "0.5em" }}
                floatingLabelText={
                  <div style={{ whiteSpace: "nowrap" }}>
                    Number of favorites to select
                  </div>
                }
                floatingLabelFixed={true}
                value={this.props.settings.rank_labels_favorite}
                onChange={(e, v) =>
                  this.props.updateSetting("rank_labels_favorite", v)
                }
              />
            ) : null}
          </div>
        ) : null}
      </div>
    );
  }
}

export default connectToStores(BallotingSetup);



// WEBPACK FOOTER //
// ./src/app/components/balloting-setup.jsx